import { useQuery } from '@apollo/client';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import QnAForm from 'components/QnA/QnAForm';
import { useUser } from 'contexts/userContext';
import {
  GET_PROMOTION_BY_USER,
  GetPromotionByUserResponse,
  getPromotionByUserVariables,
} from 'graphql/query/qna';
import { User } from 'types';

const SelfPromotionalQnA = () => {
  const { user: loggedInUser } = useUser();
  const { data: promotionQnAs, loading: loadingPromotionQnA } = useQuery<
    GetPromotionByUserResponse,
    getPromotionByUserVariables
  >(GET_PROMOTION_BY_USER, { variables: { userId: loggedInUser?._id as string } });
  return (
    <Navbar goBackButtonConfig={{ title: 'Promotional Questions' }}>
      {loadingPromotionQnA ? (
        <LoadingIndicator />
      ) : (
        <QnAForm
          initialQnAs={promotionQnAs?.getPromotionByUser ?? []}
          employee={loggedInUser as User}
        />
      )}
    </Navbar>
  );
};

export default SelfPromotionalQnA;
